import { render, staticRenderFns } from "./moduleInvoice.vue?vue&type=template&id=9953132a&"
import script from "./moduleInvoice.vue?vue&type=script&lang=js&"
export * from "./moduleInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports